let language = {
    200001:"当前产品不存在",
    200020:"产品不是 sku 产品",
    200064:"该产品不是成品"
};

export { language }